import React, { useContext, useEffect, useState } from "react";

import "../../index.scss";
import "./style.modules.scss";

import { Droppable } from "react-beautiful-dnd";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Skeleton from "@material-ui/lab/Skeleton";

import ContentOptionsPopover from "../../ContentOptionsPopover";
import { evaluationTypes } from "../../NodeTypes";
import ImportContentModal from "../../../ImportContentModal";
import {
  linkElementToBlock,
  removeBlockElement,
  getMenuData,
  getLearningNode,
} from "../../../../../services/NexiDigitalAPI";

import { statusTypes } from "containers/PeopleCraft/ContentPage/StatusTypes";
import { LMCreateContext } from "../../../LearningManagementNew/Contexts/LMContext";

import { useNodesTree } from "containers/PeopleCraft/LearningManagementNew/Components/NodesTree/hooks/useNodesTree";

import { KnowledgeAssessmentCard } from "./KnowledgeAssessmentCard";
import { PreTestKnowledgeCard } from "./PreTestKnowledgeCard";

export const PreTest = ({ blockData, baseNodeLevel, permissionLearningPage, index }) => {
  const { nodeSelectItem } = useNodesTree();
  const { nodeData, setNodeData, addNode } = useContext(LMCreateContext);
  const { idCompany } = getMenuData();
  const blockEditRedirect =
    !permissionLearningPage ||
    (!!nodeData.redirect && (!nodeData.idCompany || nodeData.idCompany !== idCompany));

  const [showImportContentModal, setShowImportContentModal] = useState(false);

  const [selectedContentType, setSelectedContentType] = useState("");
  const [loadingLinkData, setLoadingLinkData] = useState(false);
  const [loadingDeleteBlockElement, setLoadingDeleteBlockElement] = useState(false);
  const [_elementItem, setElementItem] = useState(nodeData.blocks[index]?.elements);

  useEffect(() => {
    setElementItem(nodeData.blocks[index]?.elements || []);
  }, [index, nodeData.blocks]);

  const linkContentToBlock = (contentData, contentType, status) => {
    if (showImportContentModal) setShowImportContentModal(false);
    const newContentType = contentType || "EVALUATION";
    setLoadingLinkData(blockData.idBlock);
    const linkBlockData = {
      idBlock: blockData.idBlock,
      idElement: contentData.idEvaluation,
      elementType: newContentType,
    };
    linkElementToBlock(blockData.idBlock, linkBlockData)
      .then(() => {
        contentData.hasChildNodes = 0;
        contentData.childNodes = [];
        contentData.entryPoint = 1;
        contentData.complete = true;

        const parentNodeCode = nodeData.nodeCode;

        if (newContentType === "NODE") {
          addNode(parentNodeCode, contentData);

          if (status === "IMPORT") {
            // IMPORTA A PÁGINA E CONTINUA NA MESMA PÁGINA.
            getLearningNode(parentNodeCode).then((res) => {
              const nodeDataResult = res.data.result;
              setNodeData(nodeDataResult);
            });
          } else {
            //VAI PARA A PÁGINA DO NÓ
            nodeSelectItem(contentData);
          }
        } else {
          getLearningNode(parentNodeCode).then((res) => {
            const nodeDataResult = res.data.result;
            setNodeData(nodeDataResult);
          });
        }
      })
      .catch((err) => {
        console.log("Error linking", err?.request || err);
      })
      .finally(() => {
        setLoadingLinkData(false);
      });
  };

  const removeNode = (node) => {
    const payload =
      node.elementType === "NODE"
        ? { nodeCode: node?.data.nodeCode ? node?.data.nodeCode : node?.data.originalNodeCode }
        : {};

    setLoadingDeleteBlockElement(node.idBlockElement);

    removeBlockElement(node.idBlockElement, payload)
      .then((res) => {
        const filteredElementList = _elementItem?.filter(
          (obj) => obj.idBlockElement !== node.idBlockElement,
        );

        let newNodeData = { ...nodeData };

        newNodeData.blocks[index].elements = filteredElementList;

        setNodeData(newNodeData);
      })

      .catch((err) => {
        console.log("error delete", err);
      })

      .finally(() => {
        setElementItem([]);
        setLoadingDeleteBlockElement(false);
      });
  };

  return (
    <div className="preTestCard">
      {showImportContentModal && (
        <ImportContentModal
          nodeData={nodeData}
          title={""}
          denyAction={() => setShowImportContentModal(false)}
          preChosenModalPath={5}
          disablingBackNavigation={true}
          blockData={blockData}
          returnNodeData={(nodeData, status) => linkContentToBlock(nodeData, "NODE", "IMPORT")}
          returnContentData={(contentData, elementType) =>
            linkContentToBlock(contentData, elementType, null)
          }
        />
      )}
      <Droppable
        type="element-list"
        droppableId={`element-list-${index}`}
        isDropDisabled={!permissionLearningPage}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="node-manager-content-list-wrapper"
          >
            {_elementItem && _elementItem.length > 0 ? (
              <>
                <PreTestKnowledgeCard
                  elementItem={_elementItem[0]}
                  removeNode={removeNode}
                  loadingDeleteBlockElement={loadingDeleteBlockElement}
                  permissionLearningPage={permissionLearningPage}
                  blockData={blockData}
                  nodeData={nodeData}
                />
              </>
            ) : (
              <>
                <KnowledgeAssessmentCard />
              </>
            )}
            {provided.placeholder}

            {loadingLinkData && (
              <Skeleton
                variant="rect"
                width={600}
                height={90}
                style={{ borderRadius: 10, marginBottom: 20 }}
              />
            )}
            {_elementItem?.length === 0 && (
              <div className="node-manager-type-list-add-container">
                <>
                  <ContentOptionsPopover
                    addContentNode={null}
                    redirectWithPreChosed={evaluationTypes.KNOWLEDGE}
                    nodeData={nodeData}
                    disabled={
                      blockEditRedirect ||
                      ([statusTypes.ARCHIVED, statusTypes.PUBLISHED].includes(nodeData?.status) &&
                        nodeData?.nodeType !== "ORGANIZATION")
                    }
                    linkContentToBlock={linkContentToBlock}
                    setSelectedContentType={setSelectedContentType}
                    baseNodeLevel={baseNodeLevel}
                    blockData={blockData}
                  />
                  <CloudUploadIcon
                    onClick={() => setShowImportContentModal(true)}
                    style={{ fontSize: 40, marginLeft: 10 }}
                    className={`content-options-add ${
                      blockEditRedirect ||
                      ([statusTypes.ARCHIVED, statusTypes.PUBLISHED].includes(nodeData?.status) &&
                        nodeData?.nodeType !== "ORGANIZATION")
                        ? "content-options-disabled"
                        : ""
                    }`}
                  />
                </>
              </div>
            )}
          </div>
        )}
      </Droppable>
    </div>
  );
};
